// extracted by mini-css-extract-plugin
export var active = "_bd-7";
export var container = "_bd-0";
export var evenWidth = "_bd-4";
export var large = "_bd-5";
export var outlet = "_bd-8";
export var slide = "_bd-2";
export var small = "_bd-6";
export var tab = "_bd-3";
export var tabs = "_bd-1";